e4.favorites = {
    bindEventsDone: false,
    init: function () {
        if ( jQuery( '.js-e-product-favorites' ).length > 0 ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists' );
                e4.favorites.bindEvents();
            } );
        }
        if ( jQuery( '.js-e-nav-item-favorites' ).length > 0 ) {
            e4.favorites.updateQuantityInfo();
        }
        var jCart = jQuery( '.js-e-cart' );
        if ( jCart.length === 1 ) {
            jCart.one( 'loaded.e4.cart', function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists' );
                e4.favorites.bindEvents();
            } );
        }
        var jSearchForm = jQuery( '.js-e-search-form' );
        if ( jSearchForm.length === 1 ) {
            jSearchForm.one( 'loaded.e4.search', function () {
                e4.handlebars.registerTemplates( '.js-e-handlebars-tmpl-favorites-lists' );
                e4.favorites.bindEvents();
            } );
        }
    },
    cart:{
        toggleIcon: function ( jInput ) {
            if ( jInput.closest( '.js-e-product-favorites-lists' ).find( 'input:checked' ).length > 0 ) {
                jInput.closest( '.js-eldorado-cart-favorites' ).find( '.eldorado-productlist-addtofavorites-icon' ).addClass( 'eldorado-addedtofavoritlist' );
            }
            else {
                jInput.closest( '.js-eldorado-cart-favorites' ).find( '.eldorado-productlist-addtofavorites-icon' ).removeClass( 'eldorado-addedtofavoritlist' );
            }
        },
        toggleList: function ( domInput ) {
            var jInput = jQuery( domInput );
            if ( jInput.prop( 'checked' ) === true ) {
                e4.favorites.cart.addToList( jInput );
            }
            else {
                e4.favorites.cart.removeFromList( jInput );
            }
        },
        addToList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: e4.settings.ecom.favorites.url + '?action=AddCartToFavoritList&favoriteListId=' + jInput.data( 'listId' )  + '&Redirect=false'
            }, function ( data ) {
                jInput.closest('.dropdown').find('.js-eldorado-add-all-products-to-favoritlist-btn').trigger('click');
                e4.favorites.cart.toggleIcon(jInput);
            } );
        },
        removeFromList: function ( jInput ) {
            jInput.prop( 'disabled', true );
            e4.cc.ajax( {
                url: jInput.data( 'url-remove' ) + '&Redirect=false'
            }, function ( data ) {
                jInput.prop( 'disabled', false );
                e4.favorites.toggleIcon( jInput );
            } );
        }
    },
    bindEvents: function () {
        if ( e4.favorites.bindEventsDone === false ) {
            e4.favorites.bindEventsDone = true;
            jQuery( document )
            .on( 'change', '.js-eldorado-cart-favorites-list-input', function ( event ) {
                e4.favorites.cart.toggleList( event.target );
            } )
            .on( 'change', '.js-e-product-favorites-list-input', function ( event ) {
                e4.favorites.toggleList( event.target );
            } )
            .on( 'click', '.js-eldorado-favoritlist-addtocart-btn', function ( event ) {
                event.preventDefault();
                event.stopPropagation();
                let jInputWrapper = jQuery( event.currentTarget ).closest( '.js-eldorado-favoritlist-item-inputs-wrapper' ),
                    objFormData   = {};

                jQuery.each( jInputWrapper.find( 'input' ), function ( intIndex, domInput ) {
                    var jInput = jQuery( domInput );
                    objFormData[ jInput.attr( 'name' ) ] = jInput.val();
                } );
                e4.cart.addProduct( objFormData );
            } )
            .on( 'click', '.js-e-product-favorites-add-new-list-submit-btn', function ( event ) {
                e4.favorites.createNewList( event.target );
            } )
            .on( 'click', '.js-eldorado-add-all-products-to-favoritlist-btn', function ( event ) {
                event.preventDefault();
                event.stopPropagation();
                console.log( '__ADD all' );

            } )
            .on( 'click', '.js-eldorado-add-all-favorits-to-cart-btn', function ( event ) {
                event.preventDefault();
                event.stopPropagation();
                const jFavoritContainer = jQuery( event.currentTarget ).closest( '.js-e-favorite-list' );
                let postData   = {},
                    inputIndex = 0;

                postData[ 'CartCmd' ] = 'addmulti';
                postData[ 'Redirect' ] = 'false';
                postData[ 'OrderContext' ] = eldorado.contextcart;

                jFavoritContainer.find( '.js-eldorado-favoritlist-item-inputs-wrapper' ).each( function ( intIndex, domElement ) {
                    const jInputWrapper = jQuery( domElement );

                    postData[ 'ProductLoopCounter' + inputIndex ] = inputIndex;
                    postData[ 'ProductID' + inputIndex ] = jInputWrapper.find( 'input[name="ProductID"]' ).val();
                    postData[ 'VariantID' + inputIndex ] = jInputWrapper.find( 'input[name="VariantID"]' ).val();
                    postData[ 'UnitID' + inputIndex ] = '';
                    postData[ 'Quantity' + inputIndex ] = jInputWrapper.find( 'input[name="Quantity"]' ).val();
                    ++inputIndex;
                } );
                e4.cart.addProduct( postData );
            } )
            .on( 'keydown', '.js-e-product-favorites-add-new-list-name-input', function ( event ) {
                if ( event.keyCode === 13 ) {
                    event.preventDefault();
                    event.stopPropagation();
                    jQuery( event.target ).closest( '.js-e-product-favorites-add-new-list' ).find( '.js-e-product-favorites-add-new-list-submit-btn' ).trigger( 'click' );
                }
            } )
            //.on( 'shown.bs.collapse', '.js-e-product-favorites-add-new-list', e4.favorites.setNewListInputFocus )
            .on( 'show.bs.dropdown', '.js-eldorado-cart-favorites', e4.favorites.getListData )

            .on( 'shown.bs.collapse', '.js-e-product-favorites-add-new-list', e4.favorites.setNewListInputFocus )
            .on( 'show.bs.dropdown', '.js-e-product-favorites', e4.favorites.getListData )
            .on( 'hidden.bs.dropdown', '.js-e-product-favorites', e4.favorites.clearLists );
        }
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: e4.settings.ecom.favorites.url,
            dataType: 'json',
            method: 'GET',
            cache: false
        }, objAjaxSettings ) );
        jqXHR.done( function ( jsonData ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( jsonData );
            }
        } );
        jqXHR.fail( function ( data, textStatus, errorThrown ) {
            console.error( data, textStatus, errorThrown );
        } );
    },
    toggleList: function ( domInput ) {
        var jInput = jQuery( domInput );
        if ( jInput.prop( 'checked' ) === true ) {
            e4.favorites.addToList( jInput );
        }
        else {
            e4.favorites.removeFromList( jInput );
        }
    },
    addToList: function ( jInput ) {
        jInput.prop( 'disabled', true );
        e4.cc.ajax( {
            url: jInput.data( 'url-add' ) + '&Redirect=false'
        }, function ( data ) {
            jInput.prop( 'disabled', false );
            e4.favorites.toggleIcon( jInput );
        } );
    },
    removeFromList: function ( jInput ) {
        jInput.prop( 'disabled', true );
        e4.cc.ajax( {
            url: jInput.data( 'url-remove' ) + '&Redirect=false'
        }, function ( data ) {
            jInput.prop( 'disabled', false );
            e4.favorites.toggleIcon( jInput );
        } );
    },
    toggleIcon: function ( jInput ) {
        if ( jInput.closest( '.js-e-product-favorites-lists' ).find( 'input:checked' ).length > 0 ) {
            jInput.closest( '.js-e-product-favorites' ).find( '.eldorado-productlist-addtofavorites-icon' ).addClass( 'eldorado-addedtofavoritlist' );
        }
        else {
            jInput.closest( '.js-e-product-favorites' ).find( '.eldorado-productlist-addtofavorites-icon' ).removeClass( 'eldorado-addedtofavoritlist' );
        }
        e4.favorites.updateQuantityInfo();
    },
    updateQuantityInfo: function ( intQuantity ) {
        var jFavoritesQuantity = jQuery( '.js-e-favorites-quantity' );
        if ( jFavoritesQuantity.length > 0 ) {
            if ( jQuery.isNumeric( intQuantity ) === false ) {
                e4.favorites.ajax( {
                    method: 'GET'
                }, function ( jsonData ) {
                    if ( jQuery.isNumeric( jsonData.count ) === true ) {
                        e4.favorites.updateQuantityInfo( jsonData.count );
                    }
                } );
            }
            else if ( intQuantity === 0 ) {
                jFavoritesQuantity.empty();
            }
            else {
                jFavoritesQuantity.html( intQuantity );
            }
        }
    },
    addToNewList: function ( jListItems, jsonData ) {
        var jNewListInput = jListItems.find( '.js-e-product-favorites-list-input[data-list-id="' + jsonData.lastAdded.id + '"]' );
        jNewListInput.prop( 'checked', true );
        e4.favorites.toggleList( jNewListInput.get( 0 ) );
        jNewListInput.closest( '.dropdown-item' ).addClass( 'bg-light' );
    },
    setNewListInputFocus: function ( event ) {
        jQuery( event.target ).find( '.js-e-product-favorites-add-new-list-name-input' ).trigger( 'focus' );
    },
    createNewList: function ( domElm ) {
        let jFavoriteList,
        boolCartPage = false;

        if(jQuery( domElm ).closest( '.js-e-product-favorites' ).length === 0){
            jFavoriteList = jQuery( domElm ).closest(  '.js-eldorado-cart-favorites' );
            boolCartPage = true;
        } else {
            jFavoriteList = jQuery( domElm ).closest( '.js-e-product-favorites' );
        }

        let objProductDataSettings = jFavoriteList.data(),
            jListItems             = jFavoriteList.find( '.js-e-product-favorites-lists' ),
            jNameInput             = jFavoriteList.find( '.js-e-product-favorites-add-new-list-name-input' ),
            strUrl                 = jFavoriteList.data( 'favoritesPage' ) + '&CC' + jFavoriteList.data( 'paragraphId' ) + '=CreateList';

        if ( jNameInput.val() !== '' ) {
            e4.favorites.ajax( {
                url: strUrl,
                method: 'POST',
                dataType: 'html',
                beforeSend: function () {
                    jFavoriteList.find( '.js-e-product-favorites-loader' ).addClass( 'is-loading' );
                },
                data: {
                    CC_Type: 'List',
                    CC_Name: jNameInput.val(),
                    Redirect: false
                }
            }, function () {
                jFavoriteList.find( '.js-e-product-favorites-loader' ).removeClass( 'is-loading' );
                console.log( 'POST callback get', domElm, strUrl )
                e4.favorites.ajax( {
                    data: objProductDataSettings
                }, function ( jsonData ) {
                    e4.favorites.buildList( jListItems, jsonData );
                    if ( !boolCartPage ){
                        e4.favorites.addToNewList( jListItems, jsonData );
                    }
                } );
                jNameInput.val( '' );
                jFavoriteList.find( '.js-e-product-favorites-add-new-list' ).collapse( 'hide' );
            } );
        }
        else {
            jNameInput.trigger( 'focus' );
        }
    },
    getListData: function ( event ) {
        var objProductDataSettings = jQuery( event.target ).data(),
            jListItems             = jQuery( event.target ).find( '.js-e-product-favorites-lists' );
        e4.favorites.ajax( {
            data: objProductDataSettings,
            beforeSend: function () {
                jQuery( event.target ).find( '.js-e-product-favorites-loader' ).addClass( 'is-loading' );
            }
        }, function ( jsonData ) {
            e4.favorites.buildList( jListItems, jsonData );
            jQuery( event.target ).find( '.js-e-product-favorites-loader' ).removeClass( 'is-loading' );
        } );
    },
    clearLists: function ( event ) {
        jQuery( event.target ).find( '.js-e-product-favorites-lists' ).html( '' );
    },
    buildList: function ( jListItems, jsonData ) {
        jListItems.html( e4.handlebars.tmpl.favoritesLists( jsonData ) );
    }
};
